import React from 'react'
import { Switch, Route } from 'react-router-dom'
import slug from 'constants/slug'
import QAList from './list'
import QACreate from './create'
import QAEdit from './edit'

export default props => (
  <Switch>
    <Route
      exact
      path={slug.qa.list}
      render={matchProps => <QAList {...matchProps} {...props} />}
    />
    <Route
      path={slug.qa.create}
      render={matchProps => <QACreate {...matchProps} {...props} />}
    />
    <Route path={slug.qa.edit} component={QAEdit} />
  </Switch>
)



// WEBPACK FOOTER //
// ./src/containers/qa/index.js